export default __webpack_public_path__ + "static/media/heart-1-2.34a0074d.svg";